export const FontSizes = {
	XS: 8,
	SM: 10,
	MD: 13,
	LG: 15,
	XL: 24,
};
